import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function Metaversenum() {
  return (
    <section className="metaverse_num" style={{ background: "#F9F9F9" }}>
      <Container>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <Row>
              <Col xs={6} md={3} lg={3} xl={3} xxl={3}>
                <div className="meta_num_box">
                  <div className="meta_num_content">
                    <h2>50+</h2>
                    <p>Full-Stack Developers</p>
                  </div>
                </div>
              </Col>
              <Col xs={6} md={3} lg={3} xl={3} xxl={3}>
                <div className="meta_num_box">
                  <div className="meta_num_content">
                    <h2>8+</h2>
                    <p>Years of Experience</p>
                  </div>
                </div>
              </Col>
              <Col xs={6} md={3} lg={3} xl={3} xxl={3}>
                <div className="meta_num_box">
                  <div className="meta_num_content">
                    <h2>150+</h2>
                    <p>Digital Projects Delivered</p>
                  </div>
                </div>
              </Col>
              <Col xs={6} md={3} lg={3} xl={3} xxl={3}>
                <div className="meta_num_box">
                  <div className="meta_num_content">
                    <h2>4.8</h2>
                    <p>Rating on Clutch</p>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Metaversenum;
